import React, { useState } from 'react';
import { DataManagerContainer } from './DataManager.style';;
import { ReactComponent as DataIndexMenuIcon } from "../../assets/svgs/icons/dataindex-icon.svg";
import { ReactComponent as UploadMenuIcon } from "../../assets/svgs/icons/upload-icon.svg";
import { ReactComponent as AOIsMenuIcon } from "../../assets/svgs/icons/aois-icon.svg";
import DataMenuBarIcon from '../utils/DataMenuBarIcon';
import DataIndexMenuTable from './dataIndex/DataIndexMenuTable';
import AoisMenuTable from './Aois/AoisMenuTable';
import UploadsMenuTable from './uploads/UploadsMenuTable';
import { useCustomEventListener } from 'react-custom-events';


interface DataMenu {
    icon: JSX.Element;
    menuId: string;
    title: string;  
}

const DataManager = () => {
    const [activeMenu, setActiveMenu] = useState<string | null>(null);
    const [isMenuCardOpen, setIsMenuCardOpen] = useState(false);
    const [menuAoisOpen, setMenuAoisOpen] = useState<boolean>(false);

    const DataMenuList: DataMenu[] = [
        { icon: <DataIndexMenuIcon key="DataIndexMenu" />, menuId: "dataIndex", title: "Data" },
        { icon: <UploadMenuIcon key="UploadMenu" />, menuId: "upload", title: "Upload" },
        { icon: <AOIsMenuIcon key="AOIsMenu" />, menuId: "aois", title: "AOIs" },
    ];

    const handleMenuClick = (menuId: string) => {
        if(menuId === activeMenu){
            setActiveMenu(null);
        } else{
            setActiveMenu(menuId);
            setIsMenuCardOpen(true);
        }
    };

    useCustomEventListener("openAOIProcessMenu", (data) => {
        setMenuAoisOpen(true)
        setIsMenuCardOpen(true);
        setActiveMenu("aois");
    });

    return (
        <>
            <DataManagerContainer>
                <div className="menu-container">
                    <div className="menubar_container_wrapper">
                        <div className="menubar_wrapper">
                            <div className="menu_icons">
                                {DataMenuList.map(({ icon, menuId, title }) => (
                                        <DataMenuBarIcon
                                            key={menuId}
                                            icon={icon}
                                            onClick={handleMenuClick}
                                            activeMenuItem={activeMenu}
                                            menuItem={menuId}
                                            title={title}
                                        />
                                ))}
                            </div>
                        </div>
                        {isMenuCardOpen && (
                            <div className='dataIndexTableWrapper'>
                                {<DataIndexMenuTable visible={activeMenu === "dataIndex"} setActiveMenu={setActiveMenu}/>}
                                {<AoisMenuTable visible={activeMenu === "aois"} setActiveMenu={setActiveMenu} menuAoisOpen={menuAoisOpen} setMenuAoisOpen={setMenuAoisOpen}/>}
                                {<UploadsMenuTable visible={activeMenu === "upload"} setActiveMenu={setActiveMenu} />}
                            </div>
                        )}
                    </div>

                </div>
            </DataManagerContainer>
        </>
    );
}

export default DataManager;
